import _ from 'lodash'
import JSONParse from '@/utils/JSONParse'
import { transformTimestampToMilliseconds } from '@/utils/date'

/**
 * 将接口返回的数据转换为适应表单的格式
 * @param {{}} demand 接口返回的 demand info
 * @param {[]} creationTasks 接口返回的创意要求
 */
export const cookDemand = ({ demand, creationTasks }) => {
  let newDemand = {
    ...demand,
    platform: demand.platforms,
    worktime: demand.work_hours || demand.work_days || ''
  }

  // 赋值 interactive_type（interactive_type 需要从创意要求中获取）
  if (!_.isEmpty(creationTasks)) {
    newDemand.interactive_type = creationTasks[0].creation_type
  }

  if (demand.work_days) {
    newDemand.worktime = demand.work_days + 'd'
  }

  if (demand.work_hours) {
    newDemand.worktime = demand.work_hours + 'h'
  }

  if (demand.order_time) {
    newDemand.order_time = transformTimestampToMilliseconds(demand.order_time)
  }

  if (demand.similar_demands && demand.similar_demands.length) {
    newDemand.similar_demand_ids = demand.similar_demands.map(item =>
      Number(item.id)
    )
  } else {
    newDemand.similar_demand_ids = []
  }

  // 大媒体 + 非交互素材
  // 有模板 id，则使用模板
  if (!_.isUndefined(demand.big_media_tpl_id)) {
    if (demand.big_media_tpl_id) {
      newDemand.big_media_is_use_template = 1
    } else {
      newDemand.big_media_is_use_template = 2
    }
  }

  if (!_.isUndefined(demand.big_media_creative_type)) {
    // 是对比和解说时
    if (
      ['对比', '解说'].some(item => item === demand.big_media_creative_type)
    ) {
      newDemand.big_media_creative_type_other = ''
    } else {
      // 其他
      newDemand.big_media_creative_type = '其他'
      newDemand.big_media_creative_type_other = demand.big_media_creative_type
    }
  }

  // 结算相关数据
  if (demand.is_pay === 1 && !_.isEmpty(demand.payment)) {
    newDemand = {
      ...newDemand,
      ..._.pick(demand.payment, [
        'invoice_id',
        'currency',
        'exchange_rate',
        'is_prepaid',
        'revenue_usd',
        'revenue_cny',
        'cost_usd',
        'cost_cny',
        'prepaid_percent',
        'crm_contract_no'
      ])
    }
  }

  // 拍平 channel_setting 给前端消费
  if (demand.channel_setting) {
    const channelSetting = JSONParse(demand.channel_setting)
    if (channelSetting) {
      newDemand.content_rating = channelSetting.content_rating || '-1'
      newDemand.ir_report_point = !!channelSetting.ir_report_point
      newDemand.ir_creative_genre = channelSetting.ir_creative_genre
    }
  }

  // 将 int 类型的初始值修改为空字符串，便于 UI 处理
  _.each(newDemand, (value, key) => {
    // demand info详情展示中，保留cost中为0的值
    if (value === 0 && key.indexOf('cost') === -1) newDemand[key] = ''
  })

  return newDemand
}
